// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "js/" + chunkId + "-" + {"131":"62cf36bfba135a203035","152":"7acf1af9394ef8d47522","196":"343eb5bb3f90a174bc9d","862":"c6d7c5a21409a5300f1e"}[chunkId] + ".js";
};